import { render, staticRenderFns } from "./schemeRecoverManage.vue?vue&type=template&id=4cb1afdd&scoped=true"
import script from "./schemeRecoverManage.vue?vue&type=script&lang=js"
export * from "./schemeRecoverManage.vue?vue&type=script&lang=js"
import style0 from "./schemeRecoverManage.vue?vue&type=style&index=0&id=4cb1afdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1afdd",
  null
  
)

export default component.exports